export default __webpack_public_path__ + "static/app-student-0c304b230e3eaa034544b0b6273a2c99.png";